import { render, staticRenderFns } from "./AISearchPrompts.vue?vue&type=template&id=7c79ad74&"
import script from "./AISearchPrompts.vue?vue&type=script&lang=js&"
export * from "./AISearchPrompts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports